/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function TrendingUpIcon(props) {
  return (
    <svg {...props} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1895 6.08325H10.6668V4.58325H14.0002C14.4144 4.58325 14.7502 4.91904 14.7502 5.33325V8.66658H13.2502V7.14391L9.53051 10.8636C9.23762 11.1565 8.76274 11.1565 8.46985 10.8636L6.33351 8.72725L2.53051 12.5302L1.46985 11.4696L5.80318 7.13626C6.09608 6.84336 6.57095 6.84336 6.86384 7.13626L9.00018 9.27259L12.1895 6.08325Z"
        fill="currentColor"
      />
    </svg>
  )
}

TrendingUpIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default TrendingUpIcon
